package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository


class GetTicketHistoryUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String, limit: Int = 20) = repo.getHistory(ticketId, limit)
}